import { Space, SpaceVertical } from '@looker/components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import { type FC, useState } from 'react';
import DotLoader from '../../../../../../components/DotLoader';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import type { Filter } from '../../../../../../stores/filters';
import LinkedFilter from '../LinkedFilter';

const TagCollection: FC<ICustomFilter> = ({ onChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleChildChange = (filter: Filter) => {
    if (onChange) {
      onChange(filter.expression);
    }
  };

  return (
    <SpaceVertical padding="0px 48px" gap="u2" width="100%" mb="u5" align="stretch">
      <Space gap="u2" align="center">
        <DsTypography variant="label">Tag Collection</DsTypography>
        {isLoading && <DotLoader />}
      </Space>

      <LinkedFilter
        filterName="smart_pixel_collection_filter"
        view="genome_suggestions_hcp365_collection"
        fields={['genome_suggestions_hcp365_collection.collection_name_suggestion']}
        pseudoAdvertiserIdFilterKey="genome_suggestions_hcp365_collection.pseudo_advertiser_id_filter"
        pseudoAccountIdFilterKey="genome_suggestions_hcp365_collection.pseudo_account_id_filter"
        warningMessage="Changing Collection will affect other Collection in Engagement"
        onChange={handleChildChange}
        onLoadingChange={setIsLoading}
      />
    </SpaceVertical>
  );
};

export default TagCollection;
